import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IconSizesEnum, IIcon } from '../../../icon/icon.component';

@Component({
  selector: 'i2g-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessageComponent implements OnInit {
  @Input() dirty: boolean;
  @Input() invalid: boolean;
  @Input() errorMessage: string;

  errorIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.errorIcon = {
      name: 'error',
      size: IconSizesEnum.small,
    };
  }
}
